var _rect, _ellipse, _path, _path2, _rect2, _rect3, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 70,
    height: 70,
    rx: 10,
    fill: "#EBF3FE"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.7906,
    cy: 31.5808,
    rx: 8.19192,
    ry: 8.19192,
    stroke: "#338AF3",
    strokeWidth: 3.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.666 50.2584C13.9408 47.3405 16.4143 41.2395 22.1856 39.1174",
    stroke: "#338AF3",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.915 50.2584C37.6402 47.3405 35.1668 41.2395 29.3954 39.1174",
    stroke: "#338AF3",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42.833,
    y: 44.7778,
    width: 3.88889,
    height: 17.5,
    rx: 1.94444,
    transform: "rotate(-90 42.833 44.7778)",
    fill: "#338AF3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42.833,
    y: 34.0833,
    width: 3.88889,
    height: 17.5,
    rx: 1.94444,
    transform: "rotate(-90 42.833 34.0833)",
    fill: "#338AF3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5833 2H12C6.47715 2 2 6.47715 2 12V62C2 67.5228 6.47715 72 12 72H62C67.5228 72 72 67.5229 72 62V22.4167",
    stroke: "#338AF3",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/Card.edaa1bb7bdd33507c4033c5a62ebff48.svg";
export { ForwardRef as ReactComponent };